export enum FeatureFlags {
  OrganizationBasedClinicJoin = 1,
  SQLBasedCustomerSearch = 3,
  AllowSettingVisitTag = 4,
  AllowAppointments = 5,
  AllowOpeningFutureClinics = 6,
  VisitObservations = 7,
  ReferralsandRecommendations = 8,
  IHD = 9,
  AbortVisit = 10,
  AllowVisitSalesItemOptionUpdates = 11,
  PnpNewOrder = 12,
  InAppSms = 13,
  AllowAddNewReminder = 14,
  AllowMedicalDocuments = 15,
  AllowClinicToHospitalBookings = 16,
  AllowEmailHistory = 17,
  AllowAppointmentWaitlist = 18,
  AllowProactivePrescriptionsHospitals = 19,
  AllowProactivePrescriptionsClinics = 20,
  AllowPrescriptionTable = 21,
  AllowPriorExamFindings = 22,
  AllowDiagnosesonFile = 23,
  AllowScribenoteCapture = 24,
  AllowChangingPrescribingDoctor = 25,
  PrescriptionsPendingMyApproval = 26,
}
